<template>
  <v-container id="wizard" tag="section">
    <validation-observer v-slot="{ valid }">
      <base-login-material-wizard
        ref="baseLoginMat"
        v-model="tab"
        :available-steps="availableSteps"
        :items="tabs"
        :disabled-btn-logar="!empresaSelecionada"
        :loading="loading"
        class="mx-auto"
        @click:next="next(valid)"
        @click:prev="tab--"
        @click:reset="$emit('click:reset')"
        @click:request="$emit('click:request-ferramentas-norven')"
      >
        <v-tab-item class="pb-1">
          <form autocomplete="off">
            <v-row class="mx-auto" justify="space-around">
              <!--span class="h5 font-weight-regular">BEM VINDO AO HEXA!</span-->
            </v-row>
            <v-row class="mx-auto" justify="space-around">
              <v-col cols="12" md="11">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="email"
                >
                  <v-text-field
                    v-model="email"
                    :error-messages="errors"
                    color="primary"
                    label="Email*"
                    name="email"
                    prepend-icon="mdi-email"
                    validate-on-blur
                  />
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="password"
                >
                  <v-text-field
                    v-model="password"
                    :error-messages="errors"
                    :append-icon="iconEye ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="iconEye ? 'text' : 'password'"
                    color="primary"
                    label="Senha*"
                    prepend-icon="mdi-lock-outline"
                    validate-on-blur
                    @keyup.enter="next(valid)"
                    @click:append="iconEye = !iconEye"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </form>
        </v-tab-item>
        <v-tab-item class="pb-1">
          <form>
            <v-row v-if="profilePic" class="mt-n5">
              <v-col class="align-center d-flex flex-column" cols="12" md="12">
                <v-img
                  :src="profilePic"
                  width="150"
                  height="150"
                  style="border-radius: 50%"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="mb-0 pb-0">
              <v-col cols="12" md="12">
                <v-responsive max-width="500">
                  <div class="display-1 font-weight-medium mb-6 text-center">
                    <span class="grey--text text--darken-2">
                      Selecione a empresa
                    </span>
                  </div>
                  <general-select-empresa-sistema
                    v-if="logged"
                    ref="refSelectEmp"
                    :tipo="'outlined'"
                    @change="empresaSelecionada = true"
                  />
                </v-responsive>
              </v-col>
            </v-row>
            <!-- <v-row
              no-gutters
              class="mt-n7 pt-0"
              justify="space-around"
              @click="$emit('click:request')"
            >
              <v-btn
                color="primary"
                text
              >
                Solicitar Acesso a Outra Empresa
              </v-btn>
            </v-row> -->
          </form>
        </v-tab-item>
      </base-login-material-wizard>
    </validation-observer>
  </v-container>
</template>

<script>
export default {
  components: {
    BaseLoginMaterialWizard: () =>
      import("@/components/login/base/BaseLoginMaterialWizard.vue"),
    GeneralSelectEmpresaSistema: () =>
      import("@/components/general/SelectEmpresaSistema"),
  },

  data: () => ({
    iconEye: false,
    logged: false,
    email: "",
    password: "",
    tab: 0,
    tabs: ["Login", "Empresa"],
    empresa: "",
    profilePic: null,
    empresaSelecionada: false,
    loading: false,
  }),

  computed: {
    availableSteps() {
      const steps = [0];

      if (this.email && this.password) steps.push(1);

      if (steps.includes(1)) steps.push(2);

      return steps;
    },

    siglaEmpresa() {
      return this.$store.getters.getSiglaEmpresa;
    },
  },

  methods: {
    async authentication() {
      let logged = false;
      this.loading = true;

      try {
        await this.$store.dispatch("login", {
          email: this.email,
          password: this.password,
        });
        logged = true;
      } catch (e) {
        this.$toast.error(e.message, "", { position: "topRight" });
      } finally {
        this.loading = false;
      }

      if (logged) this.profilePic = this.$store.getters.getUserProfilePicture;

      return logged;
    },

    async next(valid) {
      if (!valid) return;

      if (this.tab === 0) {
        this.logged = await this.authentication();
        if (!this.logged) {
          return;
        }
        this.$refs.baseLoginMat.activateSecondTab();
      }

      if (this.tab === this.tabs.length - 1) {
        this.loading = true;
        await this.$refs.refSelectEmp.changeSelectedEmpresa();
        this.loading = false;

        if (this.siglaEmpresa === "LITE") {
          this.$router.push("/powerups");
        } else {
          this.$router.push("/");
        }
      } else {
        this.tab++;
      }
    },
  },
};
</script>

<style lang="sass">
.v-card.v-card.v-card--account
  border-color: currentColor
  border-width: 4px

.v-icon
  color: inherit

.v-card--account,
.v-card--account:before
  border-radius: 50%
</style>
